<div class="youtube-live" #modalNews>
    <div class="header">
        <div style="display: flex">
            <div class="youtube-icon"><div></div></div>
            {{title}}
        </div>
        <div class="icon-div" *ngIf="fromModal">
            <mat-icon svgIcon="expand" (click)="openWindow()"></mat-icon>
            <mat-icon svgIcon="close" (click)="closeModal()"></mat-icon>
        </div>
    </div>
    <div class="content-body">
        <iframe allowfullscreen frameborder='0' [src]='urlVideo | safeUrl' style="width: 65%; height: 100%;" allow="autoplay; encrypted-media"></iframe>
        <iframe allowfullscreen frameborder='0' [src]='urlChat | safeUrl' style="width: 35%; height: 100%;"></iframe>
    </div>
</div>
